<template>
  <b-container>
    <h1 class="mt-2 mb-4 text-left">
      {{
        this.isEditCompetition
          ? titleLookup[0]
          : fundCreationStep === 2
          ? titleLookup[fundCreationStep][newFundDto.productData.productType]
          : titleLookup[fundCreationStep]
      }}
    </h1>
    <FundMapStepper :currentStep="fundCreationStep" />
    <NewFund
      v-if="fundCreationStep === 1"
      :isTouched="isStep1RequiredFieldsTouched"
      @is-step1-fields-filled="handleStep1Errors($event)"
    />
    <CreateApplication
      v-if="fundCreationStep === 2 && newFundDto.productData.productType === 'APPLICATION'"
      :isTouched="isStep2RequiredFieldsTouched"
      @is-step2-fields-filled="handleStep2Errors($event)"
    />
    <CreateCredit
      v-if="fundCreationStep === 2 && newFundDto.productData.productType === 'CREDIT'"
      :isTouched="isStep2RequiredFieldsTouched"
      @is-step2-fields-filled="handleStep2Errors($event)"
    />
    <CreateCapitalProduct
      v-if="fundCreationStep === 2 && newFundDto.productData.productType === 'CAPITAL_PRODUCT'"
      :isTouched="isStep2RequiredFieldsTouched"
      @is-step2-fields-filled="handleStep2Errors($event)"
    />
    <CreateCombined
      v-if="fundCreationStep === 2 && newFundDto.productData.productType === 'COMBINED'"
      :isTouched="isStep2RequiredFieldsTouched"
      @is-step2-fields-filled="handleStep2Errors($event)"
    />
    <Restrictions v-if="fundCreationStep === 3" />

    <b-row class="d-flex justify-content-center justify-content-sm-start mb-3">
      <b-button class="col-11 col-sm-3 col-md-2" @click="prevStep">Vissza</b-button>
      <b-button class="col-11 col-sm-3 col-md-2 ml-sm-2 mt-2 mt-sm-0" @click="nextStep" variant="primary"
        >Tovább</b-button
      >
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { createFund, patchFund } from '../../api/fundMap'
import FundMapStepper from '../../components/FundMapStepper.vue'
import CreateApplication from './steps/CreateApplication.vue'
import CreateCapitalProduct from './steps/CreateCapitalProduct.vue'
import CreateCombined from './steps/CreateCombined.vue'
import CreateCredit from './steps/CreateCredit.vue'
import NewFund from './steps/NewFund.vue'
import Restrictions from './steps/Restrictions.vue'
import errorToast from '../../mixins/toastError'
import successToast from '../../mixins/toastSuccess'
export default {
  mixins: [errorToast, successToast],
  data: function() {
    return {
      titleLookup: {
        0: 'Termék szerkesztése',
        1: 'Új termék rögzítése',
        2: {
          APPLICATION: 'Pályázat rögzítése',
          CREDIT: 'Hiteltermék rögzítése',
          CAPITAL_PRODUCT: 'Tőketermék rögzítése',
          COMBINED: 'Kombinált termék rögzítése'
        },
        3: 'Igénylési feltételek'
      },
      isStep1RequiredFieldsTouched: false,
      isStep1RequiredFieldsFilled: false,
      isStep2RequiredFieldsTouched: false,
      isStep2RequiredFieldsFilled: false,
      isEditCompetition: false
    }
  },
  components: {
    FundMapStepper,
    CreateApplication,
    CreateCapitalProduct,
    CreateCombined,
    CreateCredit,
    NewFund,
    Restrictions
  },
  computed: {
    ...mapGetters(['fundCreationStep', 'newFundDto'])
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    prevStep() {
      if (this.fundCreationStep === 1) {
        this.scrollToTop()
        this.$router.back()
      } else {
        this.scrollToTop()
        this.$store.dispatch('prevFundCreationStep')
      }
    },
    handleStep1Errors(value) {
      this.isStep1RequiredFieldsFilled = value
    },
    handleStep2Errors(value) {
      this.isStep2RequiredFieldsFilled = value
    },
    handleStep3Errors(value) {
      this.isStep3RequiredFieldsFilled = value
    },
    async nextStep() {
      if (this.fundCreationStep === 1 && !this.isStep1RequiredFieldsFilled) {
        this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
        return (this.isStep1RequiredFieldsTouched = true)
      }
      if (this.fundCreationStep === 2 && !this.isStep2RequiredFieldsFilled) {
        this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
        return (this.isStep2RequiredFieldsTouched = true)
      }
      const { competitionId } = this.$route.query
      if (this.fundCreationStep === 3) {
        if (this.isEditCompetition) {
          try {
            const patchResult = await patchFund(competitionId, this.newFundDto)
            this.successToast('A termék rögzítése sikeres volt!')
            setTimeout(() => {
              this.$router.push(`/competitions/details?id=${patchResult._id}`)
            }, 2000)
          } catch (e) {
            console.log(e)
          }
        } else {
          try {
            const result = await createFund(this.newFundDto)
            this.successToast('A termék rögzítése sikeres volt!')
            setTimeout(() => {
              this.$router.push(`/competitions/details?id=${result.competitionId}`)
            }, 1000)
          } catch (e) {
            this.errorToast('Hiba történt a pályázat rögzítésekor.')
          }
        }
      } else {
        this.scrollToTop()
        this.$store.dispatch('nextFundCreationStep')
      }
    }
  },
  created() {
    this.$store.dispatch('resetCreateFundStoreAction')

    const { competitionId } = this.$route.query
    if (competitionId) {
      this.isEditCompetition = true
    }
  },
  mounted() {
    window.onbeforeunload = function(e) {
      e.returnValue = ''
      return ''
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null
  }
}
</script>

<style lang="scss" scoped>
.current-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 56px;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  margin-right: 25px;
  margin-left: 10px;
  margin-bottom: 0;
  font-weight: 700;
  font-size: 32px;
}

.description {
  text-align: initial;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
}

.save-list-btn {
  width: 100%;
}

@media screen and (min-width: 576px) {
  .save-list-btn {
    width: max-content;
    margin-bottom: 0;
  }
}
@media screen and (max-width: 992px) {
  .description {
    font-size: 24px;
  }
}
</style>
